<template>
  <div>
    <DeleteWarning :isPromptActive="deleteWarningPromptValid" :data="deleteData" />
    <SupplierAddNew
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :data="sidebarData"
    />
    <vs-card>
      <b-row class="justify-content-md-start" v-if="!isMobile()">
        <b-col cols="3">
          <b-form-group label-for="item-name">
            <b-form-input
              v-model="searchedVal"
              id="smallInput"
              :placeholder="$t('Search')"
              @keyup.enter="filterSupplierList"
              size="sm"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="auto" style="padding-left: 0px !important">
          <b-button
            class="bg-primary"
            style="border-color: white"
            size="sm"
            v-on:click="filterSupplierList()"
          >
            <Icon
              icon="material-symbols:search-rounded"
              width="20"
              height="20"
            /> </b-button
        ></b-col>
        <b-col cols="12" md="auto" style="padding-left: 0px !important">
          <b-button
            style="border-color: white"
            v-on:click="getSupplierData()"
            size="sm"
            class="vs-con-loading__container bg-primary"
            id="loading-supplier-list"
          >
            <Icon
              icon="ph:list-fill"
              style="margin-right: 5px"
              width="20"
              height="20"
            />{{ $t("ListSupplier") }}
          </b-button>
        </b-col>
        <b-col cols="12" md="auto" style="padding-left: 0px !important">
          <success-btn
            :bgcolor="'bg-success'"
            :title="'AddNew'"
            :icon="'mingcute:add-line'"
            :size="'sm'"
        /></b-col>
      </b-row>
      <b-row class="justify-content-md-start" v-else>
        <b-col cols="6">
          <b-form-group label-for="item-name">
            <b-form-input
              v-model="searchedVal"
              id="smallInput"
              :placeholder="$t('Search')"
              @keyup.enter="filterSupplierList"
              size="sm"
            />
          </b-form-group>
        </b-col>
        <b-col cols="2" style="padding-left: 0px !important">
          <b-button
            class="bg-primary"
            style="border-color: white"
            size="sm"
            v-on:click="filterSupplierList()"
          >
            <Icon
              icon="material-symbols:search-rounded"
              width="20"
              height="20"
            /> </b-button
        ></b-col>
        <b-col cols="4" style="padding-left: 0px !important">
          <success-btn
            :bgcolor="'bg-success'"
            :title="'AddNew'"
            :icon="'mingcute:add-line'"
            :size="'sm'"
        /></b-col>
      </b-row>
      <ag-grid-vue
        ref="agGridTable"
        class="scroll-to-ag-grid-table ag-theme-alpine w-100 my-4 ag-grid-table"
        :columnDefs="supplierColumns"
        :defaultColDef="defaultColDef"
        :rowData="supplierList"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :pagination="true"
        @grid-ready="onGridReady"
        :suppressCopyRowsToClipboard="true"
        :suppressPaginationPanel="true"
        :localeText="localeText"
      >
      </ag-grid-vue>
    </vs-card>
  </div>
</template>
<script>
import { isMobile } from "mobile-device-detect";
import moment from "moment";
import DeleteWarning from "../../components/warning-message/DeleteWarning.vue";
import SuccessBtn from "../../components/vx-button/SuccessBtn.vue";
import { Icon } from "@iconify/vue2";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import statusShowCellRenderer from "../CellRenderers/statusShowCellRenderer.vue";
import i18nData from "../../i18n/i18nData";
import SupplierAddNew from "./SupplierAddNew.vue";
import updateDeleteBtnCellRenderer from "../CellRenderers/updateDeleteBtnCellRenderer.vue";
export default {
  components: {
    updateDeleteBtnCellRenderer,
    statusShowCellRenderer,
    DeleteWarning,
    SuccessBtn,
    Icon,
    AgGridVue,
    SupplierAddNew,
  },
  data() {
    return {
      wholeStockActions: false,
      deleteWarningPromptValid: false,
      deleteData: [],
      isMobile: function () {
        return isMobile;
      },
      searchedVal: "",
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
      },
      supplierList: [],
      supplierColumns: [],
      addNewDataSidebar: false,
      sidebarData: [],
    };
  },
  methods: {
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    toggleDataSidebar(val = false) {
      if (val == false) this.getSupplierData();
      this.addNewDataSidebar = val;
    },
    getSupplierData() {
      let type = "material";
      var vs = this.$vs;
      setTimeout(() => {
        vs.loading({
          container: `#loading-supplier-list`,
          type,
          scale: 0.5,
        });
      }, 1000);

      this.$store
        .dispatch("customer/listCustomerSupplier")
        .then((response) => {
          setTimeout(() => {
            vs.loading.close("#loading-supplier-list > .con-vs-loading");
          }, 1000);
          if (response)
            if (response.success == true) {
            } else console.log(response);
        })
        .catch((error) => {
          console.log(error);
          setTimeout(() => {
            vs.loading.close("#loading-supplier-list > .con-vs-loading");
          }, 1000);
        });
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      var defaultSortModel = [{ colId: "DepotNo", sort: "asc", sortIndex: 0 }];
      params.columnApi.applyColumnState({ state: defaultSortModel });
      this.gridApi.refreshCells(params);
    },
    getSupplierList() {
      this.supplierColumns = [];
      this.supplierList = this.supplier;

      if (this.supplierList.length > 0) {
        let columnList = Object.keys(this.supplierList[0]);
        this.supplierColumns.push({
          width: 120,
          pinned: "left",
          cellRendererFramework: "updateDeleteBtnCellRenderer",
        });
        columnList.forEach((val, index) => {
          if (val == "SupplierName") {
            this.supplierColumns.push({
              pinned: "left",
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
            });
          } else if (val.toString().includes("Date") == true)
            this.supplierColumns.push({
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
              valueFormatter: (params) => this.parseDate(params.data[val]),
              editable: true,
            });
          else if (
            val.toString().includes("Id") == false &&
            val.toString().includes("InfoType") == false
          )
            this.supplierColumns.push({
              headerName: this.$t(val),
              field: val,
              filter: "agSetColumnFilter",
            });
        });
      }
    },
    deleteSupplier() {
      this.deleteWarningPromptValid = true;
    },
    closeDeleteWarning() {
      this.deleteWarningPromptValid = false;
    },
    updateSupplier(data) {
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    deleteSubmit(data) {
      const vs = this.$vs;
      this.$store
        .dispatch("customer/deleteCustomerSupplier", data.SupplierId)
        .then((response) => {
          if (response.status == 200) {
            try {
              vs.notify({
                text: response.data.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
              this.getSupplierData();
              this.deleteWarningPromptValid = false;
            } catch (error) {
              console.log(error);
            }
          } else
            vs.notify({
              text: response.data.message.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
        })
        .catch((error) => {
          console.log(error);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    deleteSubmitAll() {
      var selectedRows = this.gridApi.getSelectedRows();
      selectedRows.forEach((val, index) => {
        this.deleteSubmit(val);
      });
    },
  },
  created() {
    if (!this.supplier) this.getSupplierData();
  },
  watch: {
    supplier(val) {
      this.getSupplierList();

      return val;
    },
  },
  computed: {
    supplier: {
      get() {
        return this.$store.state.customer.Supplier;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    localeText() {
      return i18nData[this.$i18n.locale];
    },
  },
  mounted() {
    if (!this.supplier) this.getSupplierData();
    this.$root.$on("addNewData", () => {
      this.addNewData();
    });
    this.$root.$on("deleteDataBtn", (data) => {
      this.deleteData = data;
      this.deleteSupplier(data);
    });
    this.$root.$on("editDataBtn", (data) => {
      this.updateSupplier(data);
    });
    this.$root.$on("deleteSubmit", (data) => {
      if (this.wholeStockActions == true) this.deleteSubmitAll();
      else this.deleteSubmit(data);
    });
    this.$root.$on("closeDeleteWarning", () => {
      this.closeDeleteWarning();
    });
  },
  beforeDestroy() {
    this.$root.$off("addNewData");
    this.$root.$off("deleteDataBtn");
    this.$root.$off("editDataBtn");
    this.$root.$off("deleteSubmit");
    this.$root.$off("closeDeleteWarning");
  },
};
</script>
<style lang="scss">
.scroll-to-ag-grid-table {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 130px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
